import { useCallback, useEffect, useRef, useState } from "react"
import Block from "../../components/Base/Block"
import View from "../../components/Base/View"
import httpUtil from "../../utils/httpUtil"
import util from "../../utils/util"
import { Tabs } from "antd"
import ScrollView from "../../components/Base/ScrollView"
import AfterListItem from "../../components/AfterListItem"
import Loading from "../../components/Loading"
import EmptyTip from "../../components/EmptyTip"
import RefundRequestDialog, { RefundRequestDialogRef } from "../../components/RefundRequestDialog"
import './list.scss'

const AfterSaleList = () => {

    const [columns, setColumns] = useState<{ name: string, status: number }[]>([
        {
            name: '全部',
            status: 0,
        },
        {
            name: '退款订单',
            status: 1,
        },
        {
            name: '售后商品',
            status: 2,
        },
    ])
    const [dataList, setDataList] = useState<any[][]>([[], [], []]);
    const [needRefresh, setNeedRefresh1] = useState<boolean[]>([false, false, false]);
    const [currentColumn, setCurrentColumn] = useState<number>(0);

    const [isLoading, setLoading1] = useState<boolean[]>([false, false, false]);
    const [noMore, setNoMore1] = useState<boolean[]>([false, false, false]);
    const [loadFailed, setLoadFailed1] = useState<boolean[]>([false, false, false]);

    const isSwitchColumn = useRef<boolean>(false);
    const pageNum = useRef<number[]>([1, 1, 1]);

    const [orderitemid, setOrderItemId] = useState<number>(-1)

    const refundDialog = useRef<RefundRequestDialogRef>()

    const loadList = useCallback((isRefresh: boolean, index: number) => {
        const setLoading = (index: number, loading: boolean) => {
            setLoading1((pre: boolean[]) => {
                const newList = pre.slice(0);
                newList[index] = loading;
                return newList;
            })
        }
        const setNoMore = (index: number, loading: boolean) => {
            setNoMore1((pre: boolean[]) => {
                const newList = pre.slice(0);
                newList[index] = loading;
                return newList;
            })
        }
        const setLoadFail = (index: number, loading: boolean) => {
            setLoadFailed1((pre: boolean[]) => {
                const newList = pre.slice(0);
                newList[index] = loading;
                return newList;
            })
        }
        const setNeedRefresh = (index: number, loading: boolean) => {
            setNeedRefresh1((pre: boolean[]) => {
                const newList = pre.slice(0);
                newList[index] = loading;
                return newList;
            })
        }
        if (!isRefresh && (isLoading[index] || noMore[index])) {
            return
        }
        if (isRefresh) {
            pageNum.current[index] = 1
            setNoMore(index, false)
            setLoadFail(index, false)
            setNeedRefresh(index, false)
        }
        setLoading(index, true)
        var params: any = {
            apiName: 'getaftersales',
            Type: columns[index].status,
            Page: pageNum.current[index],
            PageSize: 10,
        }
        if (orderitemid > 0) {
            params.OrderItemId = orderitemid
        }
        console.log(params)
        httpUtil.link(params, 'GET', {}, true, function (success: boolean, res: any, tips: string) {
            if (success) {
                var orders = res.data.Content
                if (orders.length > 0) {
                    pageNum.current[index] = pageNum.current[index] + 1
                } else {
                    setNoMore(index, true)
                }
                var listArray = dataList

                // 對時間進行處理
                orders.forEach(function (item: any) {
                    if (item.AutoCloseUnpayedMinutes) {
                        item.leftTimeStr = util.getLeftTimeStr(
                            item.CreatedOn,
                            item.AutoCloseUnpayedMinutes
                        )
                    }
                    if (item.OrderCancelRequestStatusId != 0) {
                        item.Id = item.OrderId
                    }
                })
                listArray[index] = isRefresh ? orders : listArray[index].concat(orders)
                setDataList(listArray)
            } else {
                setLoadFail(index, true)
            }
            setLoading(index, false)
        })
    }, [isLoading, noMore, pageNum, needRefresh, orderitemid, dataList]);

    useEffect(() => {
        document.title = "售后记录";
        const urlInfo = util.parasUrl(window.location.href);
        const params = urlInfo.params as any;
        if (params.orderitemid) {
            setColumns([
                {
                    name: '售后商品',
                    status: 2,
                },
            ])
            setOrderItemId(params.orderitemid)
        } else {
            setOrderItemId(0)
        }
    }, [])

    useEffect(() => {
        if (orderitemid !== -1) {
            loadList(true, currentColumn)
        }
    }, [orderitemid, columns, currentColumn])

    return <Block>
        <View
            className="aftersale-list"
        >
            <View className="container ">
                <View
                    className={
                        'main-container ' +
                        (columns.length > 1 ? '' : 'main-container-notab')
                    }
                >
                    <Tabs
                        centered
                        style={{
                            height: "100%",
                            overflow: "hidden"
                        }}
                        className="lists-container"
                        activeKey={`${currentColumn}`}
                        onChange={(key) => {
                            setCurrentColumn(parseInt(key));
                        }}
                        items={columns.map((list, listIndex) => {
                            return {
                                label: list.name,
                                key: `${listIndex}`,
                                children: <>
                                    <ScrollView
                                        className="list-container"
                                        scrollY={true}
                                        onReachBottom={()=>{
                                            loadList(false, currentColumn)
                                        }}
                                        enableBackToTop={true}
                                        scrollWithAnimation={true}
                                    >
                                        {dataList[listIndex].map((item, listItemIndex) => {
                                            return (
                                                <Block>
                                                    <AfterListItem
                                                        orderInfo={item}
                                                    // state={listIndex}
                                                    // onOrdercanceled={this.onOrderCalcel}
                                                    // onOrderconfirmed={this.onOrderConfirmed}
                                                    // onOrderpayed={this.onOrderPayed}
                                                    // onOpenshipmentdialog={
                                                    //     this.openShipmentListDialog
                                                    // }
                                                    // onRefundorder={this.refundOrder}
                                                    onRequestShowRefundResult={()=>{
                                                        refundDialog.current?.open(item)
                                                    }}
                                                    ></AfterListItem>
                                                </Block>
                                            )
                                        })}
                                        {isLoading?.[listIndex] ? (
                                            <Loading
                                                style={{
                                                    width: 25,
                                                    height: 25,
                                                    marginTop: 25,
                                                    marginBottom: 25,
                                                    opacity: 0.5
                                                }}

                                            ></Loading>
                                        ) : (
                                            ((noMore?.[listIndex] &&
                                                dataList[listIndex].length > 0) ||
                                                loadFailed?.[listIndex]) && (
                                                <Block>
                                                    <View
                                                        className="loading-tip"
                                                    // onClick={
                                                    //     loadFailed?.[listIndex] ? 'retryLoadMore' : ''
                                                    // }
                                                    >
                                                        {noMore?.[listIndex]
                                                            ? '没有更多了'
                                                            : '加载失败，点我重试'}
                                                    </View>
                                                </Block>
                                            )
                                        )}

                                    </ScrollView>
                                    {!isLoading?.[listIndex] &&
                                        !loadFailed?.[listIndex] &&
                                        dataList[listIndex].length === 0 && (
                                            <EmptyTip
                                                data={{
                                                    icon: require('../../images/empty_order.png'),
                                                    tip: '暂无相关售后请求',
                                                    // btn: '',
                                                }}
                                            // emptyBtnClick={this.emptyBtnClick}
                                            ></EmptyTip>
                                        )}
                                </>
                            }
                        })}
                    />
                </View>
            </View>
        </View>
        <RefundRequestDialog ref={refundDialog}></RefundRequestDialog>
    </Block>
}

export default AfterSaleList;